module.exports = __webpack_public_path__ + "static/cafe-83300f9ed04a6961c848f5c1a64708e5.png";